<template>
  <v-dialog
    v-model="_dialog"
    max-width="600px"
    @click:outside="_dialog = false"
  >
    <v-card>
      <v-card-title class="headline mb-3" style="font-weight: bold !important">ATENÇÃO</v-card-title>
      <validation-observer v-slot="{ valid }">
        <v-card-text style="font-weight: 300 !important; text-align: justify !important; font-size: 15px !important">
          <p class="mb-3">Esta ferramenta, diferentemente de todas as outras do Hexa, é apenas uma <b>interface de uso</b> de um algoritmo da própria ANEEL.</p>
          <p class="mb-3">O objetivo é facilitar a execução do algoritmo exatamente como ele é, <b>sem nenhuma adaptação ou correção dos códigos.</b> Assim, eventuais erros de execução, performance ou dificuldade com os arquivos de saída não foram corrigidos pela nossa equipe.</p>
          <p class="mb-3">Nos próximos meses desenvolveremos nosso próprio algoritmo com os mesmos testes da ANEEL para também incluir no Hexa como uma nova ferramenta, na qual todas as adaptações e correções serão implementadas.</p>
        </v-card-text>
        <v-divider />
        <v-card-actions class="pt-0 pr-6">
          <v-spacer />
          <v-btn 
            text
            class="text-h2 pa-12"
            @click="_dialog = false"
          >
            Fechar
          </v-btn>
        </v-card-actions>
      </validation-observer>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    dialog: {
      type: Boolean,
      required: true
    }
  },

  data: () => ({
    url: 'https://git.aneel.gov.br/publico/conteudos-externos/-/commit/6ac57c27c8093af5f76104d982d76cb4aa67fdfc'
  }),

  computed: {
    _dialog: {
      get() {
        return this.dialog;
      },
      set(newValue) {
        this.$emit('update:dialog', newValue);
      }
    }
  }
}
</script>